import { PhosphorGearAnchor } from "components/Atoms/PhosphorIconAnchor";
import React from "react";
import { Message } from "components/Atoms/Message";
import { routes } from "utilities/routing/generatedRoutes";

export const ConfigureICalendarTemplateMessageBox = () =>
  <Message type="info" className="flex">
    <div className="grow1 padding">
      {RESX.Template.ConfigureICalendarTemplate}
    </div>
    <PhosphorGearAnchor
      href={routes.iCalendarTemplate_List().absolute}
      layout="in-square"
      backgroundColor="transparent"
    />
  </Message>
